export const list = [
  {
    name: "Profile",
    labelKey: "tabs.profile",
    imgDark: "images/step-user-black.png",
    imgLight: "images/step-user-gold.png",
  },
  {
    name: "Preferences",
    labelKey: "tabs.preferences",
    imgDark: "images/sating.png",
    imgLight: "images/sating-gold.png",
  },
  {
    name: "My Technology",
    labelKey: "tabs.myTechnology",
    imgDark: "images/nanotechnology.png",
    imgLight: "images/nanotechnology-gold.png",
  },
  {
    name: "Legal and Privacy",
    labelKey: "tabs.legalAndPrivacy",
    imgDark: "images/privacy.png",
    imgLight: "images/privacy-gold.png",
  },
];
